import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MenuComponent } from './menu/menu.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FooterComponent } from './footer/footer.component';
import { AppMaterialModule } from './app-material/app-material.module';
import { ActivityStreamModule } from './activity-stream/activity-stream.module';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { HttpConfigInterceptor } from './interceptor/httpconfig.interceptor';
import { NgxSpinnerModule } from "ngx-spinner";
import { AuthGuard } from './auth-guard/auth-guard';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { GlobalErrorHandler } from './common-service/error-handler';
import { PreProductionModule } from './pre-production/pre-production.module';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    MenuComponent,
    FooterComponent,
    UnauthorizedComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AppMaterialModule,
    ActivityStreamModule,
    PreProductionModule,
    HttpClientModule,
    NgbModule,
    NgxSpinnerModule,
    NgIdleKeepaliveModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
      closeButton: true,
      preventDuplicates: true
    })
  ],
  exports: [],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }, AuthGuard,{provide: ErrorHandler, useClass: GlobalErrorHandler}],
  bootstrap: [AppComponent]
})
export class AppModule { }
